/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

export { App, PortletStoreApi, poeStateChanged } from './App';
